import { CircularProgress } from "@material-ui/core";
import useStyle from "./PageCircularProgress.style";

export const PageCircularProgress = () => {
  const classes = useStyle();

  return <CircularProgress size={64} className={classes.root} />;
};